import useSearchParams from "@/hooks/useSearchParams";
import { parseQuery, stringifyQuery } from "@/utils";

export type PageParamKey = "page" | "sheet_page";

const PAGE_PARAM_KEYS: PageParamKey[] = ["page", "sheet_page"];

export function usePageParam(key: PageParamKey = "page") {
  const [params, setParams] = useSearchParams<Record<string, unknown>>();

  const page = Math.max(1, Number(params[key]) || 1);

  const setPage = (nextPage: number) => {
    setParams({ [key]: nextPage > 1 ? nextPage : undefined });
  };

  return [page, setPage] as const;
}

export function omitPageParams(search: string) {
  const query = parseQuery<Record<string, unknown>>(search);
  const nextSearch = stringifyQuery(
    Object.fromEntries(
      Object.entries(query).filter(
        ([key]) => !PAGE_PARAM_KEYS.includes(key as PageParamKey)
      )
    )
  );

  return nextSearch ? `?${nextSearch}` : "";
}
